import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { clearRedirectSession, removeAzurToken } from "../utils";

export const LogoutUser = () => {
  const { instance, inProgress } = useMsal();
  const activeAccount: any = instance.getActiveAccount();
  const [isRedirected, setRedirected] = useState(false);
  const [cookiesUrl, setRedirectUrlCookie, removeUrlCookie] = useCookies([
    "redirectData",
  ]);
  useEffect(() => {
    if (inProgress === "none") {
      openNextApp();
    }
    return () => {
      clearRedirectSession();
    };
  }, [activeAccount, inProgress]);

  const openNextApp = () => {
    removeAzurToken();
    if (
      cookiesUrl.redirectData &&
      cookiesUrl.redirectData.redirectUrl &&
      cookiesUrl.redirectData.type
    ) {
      setRedirected(true);

      window.open(cookiesUrl.redirectData.redirectUrl, "_self");

      removeUrlCookie("redirectData");
    } else {
      if (!isRedirected) {
        window.open("/", "_self");
      }
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "40px 60px",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
          textAlign: "center",
          maxWidth: "450px",
        }}
      >
        {/* Success Icon */}
        <div
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            backgroundColor: "#4caf50",
            margin: "0 auto 30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            style={{ width: "50px", height: "50px" }}
            fill="white"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </div>

        <h1
          style={{
            fontSize: "28px",
            fontWeight: "600",
            color: "#333",
            marginBottom: "15px",
          }}
        >
          Logged Out Successfully
        </h1>

        {/* Spinner */}
        <div style={{ marginTop: "20px" }}>
          <div
            style={{
              border: "3px solid #f3f3f3",
              borderTop: "3px solid #4caf50",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              animation: "spin 1s linear infinite",
              margin: "0 auto",
            }}
          ></div>
        </div>

        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};
